import React from "react";
import * as PropTypes from "prop-types";
import classnames from "classnames";

import styles from "./backdrop.module.scss";

const Backdrop = ({ id = "", className, clickable = true, ...restProps }) => {
  return (
    <div
      id={id}
      className={classnames(styles["backdrop"], "_js-test_backdrop", className, {
        [styles["not-clickable"]]: !clickable,
      })}
      {...restProps}
    />
  );
};

Backdrop.propTypes = {
  className: PropTypes.string,
  clickable: PropTypes.bool,
};

export default Backdrop;
